<template>

  <div class="columns">
    <div class="column is-12">
      <table class="matching-table">
        <tbody>
          <tr class="table-row" v-for="(row, row_index) in tableData" :key="`MATCHING_TABLE_${row_index}`">
            <!--Left Cell-->
            <td class="table-element">
              <div class="table-cell">
                <div v-if="row.left" class="data-container">
                  <show-clipart-layer
                    :key="`MATCHING_CL_LEFT_${row_index}`"
                    v-if="row.left.layers && row.left.layers.length"
                    :layers="row.left.layers"
                  ></show-clipart-layer>
                  <p class="title is-6" :style="matchingRowStyles(row_index, 'L')" v-if="row.left.title && row.left.title.length">{{ row.left.title }}</p>
                </div>
                <div class="icons-container">
                  <span v-if="row_index" @click="moveCellUp('left', row_index)" >
                    <b-icon class="matching-arrow-icon" size="is-medium" icon="chevron-up-box"></b-icon>
                  </span>
                  <span v-if="row_index != matching_local.left.length - 1" @click="moveCellDown('left', row_index)" >
                    <b-icon class="matching-arrow-icon" size="is-medium" icon="chevron-down-box"></b-icon>
                  </span>
                </div> 
              </div>
            </td>

            <td style="width: 15%;"></td>
            <!--Right Cell-->
            <td class="table-element ">
              <div class="table-cell">
                <div v-if="row.right" class="data-container">
                  <show-clipart-layer
                    :key="`MATCHING_CL_RIGHT_${row_index}`"
                    v-if="row.right.layers && row.right.layers.length"
                    :layers="row.right.layers"
                  ></show-clipart-layer>
                  <p class="title is-6" :style="matchingRowStyles(row_index, 'R')" v-if="row.right.title && row.right.title.length">{{ row.right.title }}</p>
                </div> 
                <div class="icons-container">
                  <span v-if="row_index" @click="moveCellUp('right', row_index)" >
                    <b-icon class="matching-arrow-icon" size="is-medium" icon="chevron-up-box"></b-icon>
                  </span>
                  <span v-if="row_index != matching_local.right.length - 1" @click="moveCellDown('right', row_index)" >
                    <b-icon class="matching-arrow-icon" size="is-medium" icon="chevron-down-box"></b-icon>
                  </span>
                </div> 
              </div>
              
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
  </div>
</template>

<script>
import ShowClipartLayer from "../ShowClipartLayer.vue";
import {getCSSFromStyles} from '@/components/Common/StyleEditor/utils'
import { mapActions } from "vuex";
export default {
  name: "show-matching",
  props: {
    matching: {
      type: Object,
    },
  },
  components: {
    ShowClipartLayer,
  },
  data() {
    return {
      matching_local: JSON.parse(JSON.stringify(this.matching)),
    };
  },
  methods: {
    ...mapActions(['updateCurrentAnswer']),
    matchingRowStyles(index, col){
			let styles = {}
			if(this.matching_local){
        let cols_arr = []
        if(col == 'L'){
          cols_arr = this.matching_local.left
        } else if(col == 'R'){
          cols_arr = this.matching_local.right
        }

        const row = cols_arr[index]
        if(row){
          styles = getCSSFromStyles(row.styles)
        }
			}

			return styles
		},
    moveCellUp(type, current_index){
      // Reserve current & (current - 1) spot
      const arr = this.matching_local[type]
      this.matching_local[type] = [...arr.slice(0, current_index-1), arr[current_index], arr[current_index-1], ...arr.slice(current_index+1)]
    },
    moveCellDown(type, current_index){
      // Reserve current & (current + 1) spot
      const arr = this.matching_local[type]
      this.matching_local[type] = [...arr.slice(0, current_index), arr[current_index+1], arr[current_index], ...arr.slice(current_index+2)]
    },
    isAnswerCorrect(){
      let is_correct = true;
      for(let answer_row of this.matching.answers){
        
        const answer_left_index = answer_row["left"]
        const answer_right_index = answer_row["right"]
        const matching_left_obj = this.matching.left[answer_left_index]
        const matching_right_obj = this.matching.right[answer_right_index]
        
        const matched_left_index = this.matching_local.left.findIndex((obj)=>obj._id === matching_left_obj._id)
        const matched_right_index = this.matching_local.right.findIndex((obj)=>obj._id === matching_right_obj._id)

        if(matched_left_index !== matched_right_index){
          is_correct = false
          break
        }
      }
      return is_correct;
    }
  },
  computed : {
    tableData(){
      const left_length = this.matching_local.left.length
      const right_length = this.matching_local.right.length
      const max_length = Math.max(left_length, right_length)
      let data = []
      for(let i = 0;i < max_length;i++){
        data.push({
          left : this.matching_local.left[i],
          right : this.matching_local.right[i],
        })
      }

      return data
    }
  },
  watch: {
    matching: {
      handler: function(new_value) {
        this.matching_local = JSON.parse(JSON.stringify(new_value));
      },
      deep: true,
    },
    matching_local: {
      handler: function() {
        this.updateCurrentAnswer({ key : 'matching', value : this.isAnswerCorrect() })
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.matching-table{
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 16px;
}
.matching-arrow-icon{
  color: #3a0ca3;
}
.icons-container{
  display: flex;
  flex-direction: column;
  width: 40px;
}
.data-container{
  width: calc(100% - 40px);
}
.table-cell{
  display : flex; 
  align-items: center;
}
.table-element {
  border: 2px solid rgb(42 205 193);
  border-width: 0 0 1 px;
  padding: 10px;
  vertical-align: middle;
}
.table-element h2 {
  margin-left: 8px;
  padding: 2px;
  color: rgb(34, 32, 32);
}
.list {
  position: relative; /* position of list container must be set to `relative` */
}
.list > *.dragging {
  width: 100%;
  border-left: 6px solid rgb(0, 183, 255);
  box-shadow: 10px 10px 5px -1px rgba(0, 0, 0, 0.14);
  opacity: 0.7;
}
</style>
